module.exports = __webpack_public_path__ + "./fonts/fontawesome-webfont.woff";


//////////////////
// WEBPACK FOOTER
// ./Content/fonts/fontawesome-webfont.woff?v=4.6.3
// module id = 16
// module chunks = 0